import { MouseEventHandler, TouchEventHandler, useState } from "react";

type TE = TouchEventHandler<HTMLElement>;
type ME = MouseEventHandler<HTMLElement>;

export type useLongPress = (props: { onClick: () => void; onLongPress: () => void }) => {
  onTouchStart: TE;
  onTouchEnd: TE;
  onMouseDown: ME;
  onMouseUp: ME;
};

export const useLongPress: useLongPress = ({ onClick, onLongPress }) => {
  const [timeoutIndex, setTimeoutIndex] = useState<number | null>(null);
  const [isTimeoutFired, setIsTimeoutFired] = useState<boolean>(false);

  const onStart: ME | TE = () => {
    const index = setTimeout(() => {
      onLongPress();
      setIsTimeoutFired(true);
    }, 1000);

    setTimeoutIndex(index);
  };

  const onEnd: ME | TE = () => {
    if (timeoutIndex) {
      window.clearTimeout(timeoutIndex);
    }

    if (!isTimeoutFired) {
      onClick();
      setIsTimeoutFired(false);
    }

    setTimeoutIndex(null);
  };

  return {
    onTouchStart: onStart as TE,
    onTouchEnd: onEnd as TE,
    onMouseDown: onStart as ME,
    onMouseUp: onEnd as ME,
  };
};
